import React from 'react';
import * as Tools from '../../../helpers/Tools';
import { CircleButton, Tooltip } from "../../ecosystem";

const ProxyXBtn = ({
    label,
    onClick,
    tooltipId,
}) => {

    const isMobileDevice = Tools.isMobile();

    const button = <CircleButton
        aria-describedby={tooltipId && !isMobileDevice ? tooltipId : ""}
        aria-label={tooltipId && !isMobileDevice ? "" : label}
        colorStyle='float'
        icon="x"
        size="small"
        onClick={onClick}
        as="div"
    />;

    return (tooltipId && !isMobileDevice
        ? <Tooltip
            text={label}
            tooltipId={tooltipId ? tooltipId : ""}
        >
            {button}
        </Tooltip>
        : button
   );
}

export default ProxyXBtn;
